import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';
import { use } from 'react';

const initialState = { 
    studentList: null,
    metaData: null,
    currentPage: 1,
    classId: '0',
    residenceId: '0',
    feesGroupId: '0',
    searchText: '',
    selectedIds: [],
    reset: false,
    mounted: false
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { ...initialState }; // Reset state completely
      case 'SET_SELECTED_IDS': // Handle updates to selectedIds
        return { ...state, selectedIds: action.payload };
      default:
        return { ...state, [action.type]: action.payload };
    }
  };


const FeesStudentContext = createContext();

export const FeesStudentProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (state.mounted) {
      getStudents();
    }
  }, [state.currentPage]);

 
  const getStudents = async (reset = false) => {
    dispatch({ type: 'mounted', payload: true });
    if (reset) {
        // Clear the list and reset the page before fetching new data
        dispatch({ type: 'currentPage', payload: 1 });
        dispatch({ type: 'studentList', payload: null });
        dispatch({ type: 'metaData', payload: null });
        dispatch({ type: 'reset', payload: true });
        dispatch({ type: 'SET_SELECTED_IDS', payload: [] }); // Reset selectedIds
    }

    try {
        const server_response = await ajaxSchool.fetchAllStudents({
            class_id: state.classId,
            residence_id: state.residenceId,
            fees_group_id: state.feesGroupId,
            page: reset ? 1 : state.currentPage, // Use page 1 if resetting
        });
        dispatch({ type: 'reset', payload: false });


        if (server_response.status === "OK") {
            const newTransactions = server_response.details.data;

            // Append or set the student list based on whether it's reset
            dispatch({
                type: "studentList",
                payload: reset
                    ? newTransactions // Replace list if resetting
                    : [...(state.studentList || []), ...newTransactions], // Append otherwise
            });

            // Update metaData with the response meta information
            dispatch({ type: "metaData", payload: server_response.details.meta });
        } else {
            // Handle error response
            dispatch({ type: "studentList", payload: "404" });
        }
    } catch (error) {
        dispatch({ type: "studentList", payload: "404" });
    }
};



  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  

  const filter = async()=>{
    await getStudents(true);
  }

  const setSelectedIds = (ids) => {
    dispatch({ type: 'SET_SELECTED_IDS', payload: ids });
  };

    const resetSelectedIds = () => {
        dispatch({ type: 'SET_SELECTED_IDS', payload: [] });
    };

  return(
    <FeesStudentContext.Provider value={{
      ...state, 
      dispatch, 
      getStudents,
      setCurrentPage,
      filter,
      setSelectedIds,
      resetSelectedIds
      }}>
      {children}
    </FeesStudentContext.Provider>
  )

}

export const useStudent = ()=>useContext(FeesStudentContext);

